import { FlagSvg } from '@lessonup/typescript-core/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAppServices } from '../../../components/appServices/AppServicesContext';
import { loggedInUser } from '../../../redux/selectors';
import './FlagLessonButton.less';

interface Props {
  lessonId: string;
}

const TRANSLATION_NAMESPACE = 'flagModal';

const FlagLessonButton: React.FunctionComponent<Props> = (props) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE);
  const { modals } = useAppServices();
  const user = useSelector(loggedInUser());
  if (!user) return null;

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events -- auto-generated TECH-258
    <div className="flag-lesson-button" onClick={() => modals.open('flagLesson', { lessonId: props.lessonId })}>
      <FlagSvg className="icon flag-icon" />
      <span className="flag-lesson-button__inner">{t('title')}</span>
    </div>
  );
};

export default FlagLessonButton;
